module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common-01.jpg",
      "width": "15%"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "intro"
    }
  }, [_c('strong', [_vm._v("Why Low Carb/High Fat?")])])]), _c('a', {
    attrs: {
      "id": "intro"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('strong', [_c('span', {
    staticClass: "color"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("L")]), _c('strong', [_vm._v("ow Carb/High Fat. Wow!")]), _vm._v(" How did we get here? After all those rice cakes and bran cereals, all that fat-free milk, it turns out that fats—albeit the right fats—are far better for us than those “healthy whole grains.” After a few decades of low-carb being called a “high protein diet,” we’re learning that a bit less protein and a bit more fat not only won’t make us fat, but that it actually can also make us slimmer and improve our health in the bargain.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It happened to me. Back in 2010, I discovered that, despite my HbA1c (the measure of average blood sugar over the previous three months) being completely normal, my fasting blood glucose was running just a little high, in the pre-diabetic range.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“What’s fasting blood sugar?” I hear you cry. It’s blood sugar tested upon arising, when you have, presumably, been fasting for 8 or more hours. This is obviously significantly different from what’s called post-prandial blood sugar—blood sugar tested after eating, when you expect blood sugar to be elevated at least a little. The American Diabetes Association considers 2-hour post-prandial blood sugar (taken 2 hours after a meal) of 180 or above to indicate diabetes. Personally, I try not to go above 120 on the advice of Dr. William Davis, cardiologist and author of "), _c('em', [_vm._v("Wheat Belly.")]), _vm._v(" Fasting blood sugar should be lower, of course. Between 70 and 100 is considered normal, 100 to 120 is pre-diabetic, and fasting blood sugar over 120 is a marker of diabetes. My post-prandial blood sugar was invariably golden, but my fasting blood sugar was generally between 105 and 110; I even saw it at 119 one day.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "intro"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("“I eat 20 to 30 grams of carbohydrate per day,” I told the doctor. “Where the heck is the sugar coming from?” He replied that my liver was making it from protein via gluconeogenesis. You may have heard that carbohydrates are not essential because your liver can make glucose. It turns out that my liver is really good at it.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I hasten to repeat that overall my blood sugar was great, as demonstrated by my HbA1c. It was just the fasting blood glucose. And it was driving me crazy; I know that excess sugar is destructive and that the damage is often permanent. So I went on Metformin, but my morning sugar still ran in the pre-diabetic range. We added Victoza, too. Still, the stupid fasting blood glucose was just over normal.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Flash forward about 6 months. I wanted to knock off a quick 5 to 10 pounds before a television shoot. Yeah, I’m a whole lot thinner than I used to be, but the television camera strikes fear into the hearts of many people more beautiful than me. I decided to try the Fat Fast, as outlined by Dr. Robert Atkins in "), _c('em', [_vm._v("Dr. Atkins’ New Diet Revolution.")]), _vm._v(" I’d known about the Fat Fast for years and had read the research that led Dr. Atkins to develop it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("So for a week or so I aimed for 1000 calories per day, 90 percent of them from fat. I lost weight like a charm, about a pound a day. I felt fine, clear-headed and energetic and even had a great weight-lifting workout one day.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("But far more exciting, my fasting blood sugar was normal. Normal-normal-normal.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("After the television shoot, I continued eating a higher percentage of fat. I dropped my daily protein intake from an average of 120 grams to 60 to 90 grams, adding butter, cream, avocados, nuts, and oils to make up the missing calories. Instead of a whole rib-eye steak, I’d have half a steak with butter melted over it—such deprivation.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("And my morning sugar stayed normal. Indeed, it started to run a little low. I dropped the Victoza, then the Metformin. My fasting sugar hung in the 85 to 95 range. It continues to do so till this day. I had a full blood panel done recently, and my new doctor was a little nonplussed by the results: rock-bottom triglycerides, sky-high HDL, all measures of liver and kidney health perfect, low CRP (the measure of inflammation), and my HbA1c as low as they measure it. She actually said, “This blood work is something to be proud of.” She was curious but accepting when I told her I’d done it by melting butter over steaks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I think I can confidently state that a low-carb, high-fat diet is good for me.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I’m not the only one. Superstar low-carb blogger and podcaster Jimmy Moore did a yearlong self-experiment with nutritional ketosis, testing his blood rather than his urine (this is far more accurate) and discovered that he needed to eat a lot more fat to be in deep ketosis. When he jacked up his fat intake and got his blood ketones where he wanted them, he shed 70 pounds he’d been struggling with. He looks amazing.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('strong', [_vm._v("Not Just Weight Loss")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("But the implications are far greater. Low-carb/high-fat, strongly ketogenic diets, long used for seizure control, are showing promise for treating all sorts of health problems.")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "blist"
  }, [_c('img', {
    staticClass: "width",
    attrs: {
      "alt": "Image",
      "src": "images/common.gif",
      "width": "2%"
    }
  }), _vm._v(" A study published in 2011 in the scientific journal "), _c('em', [_vm._v("PLOS One")]), _vm._v(" looked at the effects of a ketogenic diet on diabetic nephropathy—the most common cause of kidney failure—in diabetic mice. What was the result? Two months on a ketogenic diet actually reversed kidney damage. This had hitherto been virtually unheard of.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_c('img', {
    staticClass: "width",
    attrs: {
      "alt": "Image",
      "src": "images/common.gif",
      "width": "2%"
    }
  }), _vm._v(" In August 2013, "), _c('em', [_vm._v("The Clinical Journal of the American Society of Nephrology")]), _vm._v(" published the results of a small human trial, again showing an improvement in kidney function in type 2 diabetics with nephropathy after 12 weeks on a ketogenic diet. I find this not only wonderful but also happily ironic considering how many times I’ve been told my diet will damage my kidneys.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_c('img', {
    staticClass: "width",
    attrs: {
      "alt": "Image",
      "src": "images/common.gif",
      "width": "2%"
    }
  }), _vm._v(" In 2012, in the journal "), _c('em', [_vm._v("Nutrition")]), _vm._v(", Drs. Richard D. Feinman and Eugene Fine published groundbreaking work regarding the effectiveness of such diets in inhibiting cancer growth by reducing insulin signaling.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_c('img', {
    staticClass: "width",
    attrs: {
      "alt": "Image",
      "src": "images/common.gif",
      "width": "2%"
    }
  }), _vm._v(" In 2006, the journal "), _c('em', [_vm._v("Behavioral Pharmacology")]), _vm._v(" published an article about the benefits of a ketogenic diet for a broad range of neurological illnesses. Ketogenic diets have long been used to treat epilepsy, but they are now showing promise for treating Parkinson’s disease and Alzheimer’s as well. Having watched my mother succumb to dementia, this is, for me, the most thrilling possibility.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_c('img', {
    staticClass: "width",
    attrs: {
      "alt": "Image",
      "src": "images/common.gif",
      "width": "2%"
    }
  }), _vm._v(" The same article also states that ketogenic diets are being explored for limiting inflammation in general. Since inflammation now appears to be the root of a great deal of illness, from heart disease to cancer, this is no small thing.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_c('img', {
    staticClass: "width",
    attrs: {
      "alt": "Image",
      "src": "images/common.gif",
      "width": "2%"
    }
  }), _vm._v(" In 2005, "), _c('em', [_vm._v("Nutrition & Metabolism")]), _vm._v(" published an article regarding a pilot study of a ketogenic diet for treatment of polycystic ovarian syndrome (PCOS). The study found that the diet not only caused “significant” weight loss but also improved hormone balance and lowered fasting insulin.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("The Hardest Part")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While doing the Fat Fast, I found that the hardest part wasn’t eating just 1,000 or so calories per day; due to ketones suppressing appetite, that was easier than I expected. No, the hard part was getting 90 percent of my calories from fat. Unless you like olive oil shooters, it takes some doing. Most days I would hit around the 85 percent mark, which worked just fine. Since completing the Fat Fast, I don’t restrict calories most of the time, and I aim for 75 percent or more of my calories from fat.")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Even this is harder than it sounds. So often fat comes paired with carbohydrates: bread with garlic butter, French fries, fettuccine Alfredo. These foods may be high in fat, but they’re even higher in carbohydrate, and that carbohydrate can trigger your body to store the calories, including the fat calories, as fat. This is an important point, so let me be very clear: Adding lots of extra fat to your diet without simultaneously slashing carbs will make you gain weight, not lose it.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("So what are the secrets of jacking up the fat in your diet without adding carbs? And how do you do it in a sustainable, healthful way? That’s what this book is all about.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("We’re Talking Percentage of Calories, Not Volume or Weight")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s important to understand that we’re talking percentage of total calories, rather than percentage by weight or volume. For example: 4 ounces (115 g) of green beans will have 31 calo-ries, with 7 grams of carbohydrate, 2 grams of protein, and only a trace of fat. This translates to those beans getting 78 percent of their calories from carbohydrate and only 3 percent from fat.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("But because fats are very calorically dense, adding only "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" ounce (15 g) of butter and "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" ounce (15 g) of slivered almonds will create a dish with 216 calories, 75 percent of them from fat. Bring on the green beans almondine!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Please note that in this example, those green beans actually have 3 grams of fiber, a carbohydrate that most of us subtract from our total carbs. Because my MasterCook software doesn’t take this into account, the ratios in this book will not be calculated on net or usable carbs, but on total carbs. Why? Because I don’t want to do that much math, that’s why. However, if you’d like to do it yourself, here’s how:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Assume that carbohydrate and protein have 4 calories per gram and fats have 9 calories per gram. This is only loosely true, but for our purposes it is near enough. So, we have 216 calories total, but we want to subtract the 3 grams of fiber. 3 × 4 = 12, so we subtract 12 calories, for a total of 204. Our green beans almondine contain 19 grams of fat. 19 × 9 = 171. To figure out what percentage of the adjusted calorie count that constitutes, divide 171 by 204. According to my trusty calculator, that gives us 84 percent of calories from fat. All of the recipes in this book list the carb, fiber, and fat grams, so if you want to make these calculations, you certainly may. Me, I just figure my fat percentage is a little higher than the software tells me, and I don’t sweat it.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('strong', [_vm._v("A Gentle Warning")])])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("We tend to think of only fat, protein, and carbohydrate as contributing calories, but there is one other substance that contains considerable calories: alcohol. At 7 calories per gram, alcohol is more calorically dense than anything but fats. If you’re drinking, you skew your ratios; it’s hard to get your fat percentage up to 75 percent. (We won’t even talk about the carbohydrates that many alcoholic beverages bring along.) I like wine as much as the next girl, but alcohol is a luxury on a weight-loss diet, no matter how you look at it.")])])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("Ways to Increase Fat Intake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s not essential that every dish be over 75 percent fat. You can combine dishes to get the percentages you’re looking for. For instance, a piece of roasted chicken gets about 55 percent of its calories from fat. But pair it with a green salad with plenty of olive oil and the percentage for your meal can easily go up to 75 percent.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Make use of naturally high-fat foods: Nuts, bacon, avocados, olives, and fatty cheeses all add flavor and texture to your meals along with the fat you seek. You’ll find them used in abundance in these recipes. You can use heavy cream or full-fat coconut milk in your coffee, too.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Fat is a very concentrated source of nutrients: 2 tablespoons (28 g) of butter or (28 ml) oil will have 200 calories or more. Fat will quell your hunger, but most of us want to eat more than that. Yet you don’t want to blow past either your carb limit or your protein requirement. So, how do you get a full plate of food? Think water and fiber. Both water and fiber contribute no calories, no carbs, no protein, no nuthin’, to your meal, yet they can expand your portions deliciously to satisfying proportions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Low-carb vegetables are largely made up of water and fiber, and they make a great fat-delivery system: for example, salads with plenty of olive oil or mayonnaise, vegetables with butter, and celery with pâté or blue cheese dip. You get the picture—serve your vegetables with fat. Interestingly, this will greatly enhance your body’s absorption of fat-soluble vitamins and antioxidants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Think about it: 2 tablespoons (28 g) of mayonnaise has 200 calories, 99 percent of them from fat. But while those 2 tablespoons (28 g) of mayo will keep you full and energetic for quite a while, they’re barely more than a mouthful. Add a cup (70 g) of shredded cabbage, and suddenly you have a big ol’ portion of coleslaw, while adding only 15 calories and 4 grams carbohydrate, 2 of ’em being fiber, resulting in just 2 grams of usable carb.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Likewise, broths are mostly water. (Homemade bone broth is mostly water, gelatin, calcium, and sheer magic.) A half a cup (120 ml) of coconut milk has 222 calories, 91 percent of ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("them from fat, with just 3 grams of carb. But who drinks "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (120 ml) of coconut milk and feels like she’s had a meal? Combine that coconut milk with 1 cup (235 ml) of chicken broth, plus curry powder and a touch of garlic, and you’ve got a fabulous, warming soup.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Use sauces and dips to your advantage; you’ll find plenty of them in this book. Sirloin steak gets 63 percent of its calories from fat. Add a couple of tablespoons (28 g) of blue cheese butter, and that goes up to 74 percent. Two cups (110 g) of lettuce have 20 calories, only 12 percent of them from fat. Add 2 tablespoons (28 ml) vinaigrette dressing and that jumps to 160 calories, 85 percent of them from fat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Choose fatty cuts of meat—pork shoulder or spareribs, chicken and turkey dark meat with the skin on, rib-eye steak, chuck, and brisket, 70/30 ground beef instead of the pricey 90/10 stuff, and of course, everybody’s favorite, bacon. If you’re choosing a lower-fat protein—fish, chicken breast, or the like—again, use a fatty sauce and add a salad or vegetable with a fatty dressing on the side.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Your meals will be very nutrient dense and high in calories. This is okay; if you pay attention to your hunger, you will very quickly learn to eat to satiety, rather than eating just because the food is there. I have long since reached the point where I eat two good-size meals per day, with a snack if I’m feeling peckish in between. If you’re used to the constant, driving hunger of a low-fat diet based on grains, this will seem incredible, even impossible. Don’t force it. Just shift your macronutrient balance and pay attention to your hunger.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("How High in Fat Are These Recipes?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’ve mostly kept them in the range of 70 percent of calories from fat or higher, but there are some exceptions. Why? Sometimes, as with crackers, I made an exception because I felt the recipes filled an important culinary niche, and they would probably be eaten with something fatty anyway. Sometimes it was because, hey, it’s 68 percent, and geez, I think it’s a good recipe.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("For Fat Fasters")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Because these recipes dip as low as the high 60-something percent range in fat content, not all of them are appropriate for fat fasting. For those of you who are fat fasting, I have highlighted fat percentages over 80 percent so that you can easily pick out the suitable recipes. It’s up to you to stick to 200-calorie portions.")])])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("On Taking Control")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Celebrity chef Emeril Lagasse likes to say, regarding various seasonings, “You want more? Put in more. You want a little less? Use less. ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Hey, we’re just cooking, it’s not rocket science.” These are words to live by.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I love cilantro; it tastes like the very essence of fresh and green to me. But if you’re one of those people who thinks cilantro tastes like soap, leave it out. I’ve been known to get up in the morning and eat a jalapeño and Monterey Jack omelet with salsa and habanero hot sauce because I love breathing fire. You don’t? Cut back on the hot sauce. You think I’m a big wussy? Add more.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("As my professional idol Peg Bracken said, it’s all a matter of deciding who’s in charge here, you or the food.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("Regarding Microwave Ovens")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I use my microwave all the time, not just for reheating leftovers, but also for cooking, especially for steaming vegetables. I know of no simpler nor more satisfactory method, and my Tupperware microwave steamer is out of the cabinet more often than in it. Furthermore, I have seen some fairly convincing arguments stating that microwave steaming of vegetables retains more nutrients than most other cooking methods.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I also often cook bacon in the microwave; I haunted the local thrift store until I found a circular microwave bacon tray that would go around on my microwave’s turntable.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("However, I suspect that at least some of you will be appalled that I would even consider using a microwave. There is a faction that considers them, and all food cooked in them, to be horribly dangerous. I’m not going to argue the point here. Just take it as a given that anything I direct to cook in the microwave, you are welcome to cook on your stovetop.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5dde904","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 66
// module chunks = 0